const INCENTIVE_VARIANTS = {
    dialogueBox: 'dialogue-box',     // dialogue box on top of white background: the new CONTROL
    compactPage: 'compact-page',     // grape top part, with smaller controls of above, but no dialogue box wrapper
};

export default INCENTIVE_VARIANTS;
